import { frontendURL } from '../../../helper/URLHelper';
import TicketsIndex from './pages/TicketsIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets'),
    name: 'tickets_index',
    component: TicketsIndex,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
